import { authSlice } from '@wellesley/auth/authSlice'
import { AppsLink } from '@wellesley/router/AppsLink'
import { UserMenuDropdown } from '@wellesley/user'
import { LogIn } from 'lucide-react'
import { useSelector } from 'react-redux'

const AuthButton = () => {
  return (
    <AppsLink to="/signin">
      <div className="flex size-m items-center justify-center rounded-m bg-blue-500 text-white">
        <LogIn size={20} />
      </div>
    </AppsLink>
  )
}

export const Profile = () => {
  const isAuthenticated = useSelector(authSlice.selectors.selectIsAuthenticated)

  return (
    <div className="mt-s">
      {isAuthenticated ? (
        <UserMenuDropdown tooltipText="Profile menu" />
      ) : (
        <AuthButton />
      )}
    </div>
  )
}
